document.addEventListener('giftship.loaded', function() {
  // アコーディオン本体とオプション行の親要素取得
  const gsAppContainer = document.getElementById('gsAppContainer');
  const textContainer = gsAppContainer.querySelector('.gs__wrapper > .gs__form-options-wrapper');

  const submitButton = document.querySelector('button[type="submit"].product-form__submit');

  // .gs__product-option.gs__row を全て取得
  const optionRows = textContainer.querySelectorAll('.gs__product-option.gs__row');

  // アコーディオンの中身全体(div)をラップ
  let optionRowsWrapper = textContainer.querySelector('.custom-gs-accordion-content');
  if (!optionRowsWrapper) {
    optionRowsWrapper = document.createElement('div');
    optionRowsWrapper.className = 'custom-gs-accordion-content';
    // optionRowsをまとめてラップする
    // 挿入箇所は最初のoptionRowの直前
    if (optionRows.length > 0) {
      optionRows[0].parentNode.insertBefore(optionRowsWrapper, optionRows[0]);
      optionRows.forEach(function(row) {
        optionRowsWrapper.appendChild(row);
      });
    }
  }

  // 初期状態：アコーディオン閉じる
  optionRowsWrapper.style.overflow = 'hidden';
  optionRowsWrapper.style.maxHeight = '0px';
  optionRowsWrapper.style.transition = 'max-height 0.3s cubic-bezier(0.4,0,0.2,1)';
  optionRows.forEach(function(row) {
    row.setAttribute('data-gs-accordion', 'closed');
  });

  if (textContainer.hasChildNodes()) {
    // タイトル用のEl作成
    const titleEl = document.createElement('p');
    titleEl.innerHTML = '<span><svg class="c-icon c-icon__gift" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.2513 2.16602C5.83138 2.16602 5.42865 2.33283 5.13172 2.62976C4.83478 2.9267 4.66797 3.32942 4.66797 3.74935C4.66797 4.16928 4.83478 4.572 5.13172 4.86893C5.42865 5.16587 5.83138 5.33268 6.2513 5.33268H9.34888L9.34885 5.33259C9.23161 4.96236 9.04798 4.47401 8.78194 3.99031C8.23829 3.00185 7.43159 2.16602 6.2513 2.16602ZM1.66797 5.33301H4.2103C3.86063 4.88238 3.66797 4.3258 3.66797 3.74935C3.66797 3.06421 3.94014 2.40713 4.42461 1.92266C4.90908 1.43819 5.56616 1.16602 6.2513 1.16602C7.98769 1.16602 9.05598 2.41351 9.65816 3.50839C9.79054 3.74908 9.90433 3.9889 10.0014 4.21681C10.0984 3.9889 10.2122 3.74908 10.3446 3.50839C10.9468 2.41351 12.0151 1.16602 13.7515 1.16602C14.4366 1.16602 15.0937 1.43819 15.5782 1.92266C16.0626 2.40713 16.3348 3.06421 16.3348 3.74935C16.3348 4.3258 16.1421 4.88238 15.7925 5.33301H18.3346C18.6108 5.33301 18.8346 5.55687 18.8346 5.83301V9.99967C18.8346 10.2758 18.6108 10.4997 18.3346 10.4997H17.1683V18.3328C17.1683 18.609 16.9444 18.8328 16.6683 18.8328H10.0144L10.0015 18.833L9.98853 18.8328H3.33496C3.05882 18.8328 2.83496 18.609 2.83496 18.3328V10.4997H1.66797C1.39183 10.4997 1.16797 10.2758 1.16797 9.99967V5.83301C1.16797 5.55687 1.39183 5.33301 1.66797 5.33301ZM10.5015 17.8328H16.1683V10.4997H10.5015V17.8328ZM9.50146 10.4997V17.8328H3.83496V10.4997H9.50146ZM10.5015 9.49967H16.6554L16.6683 9.49951L16.6812 9.49967H17.8346V6.33301H10.5015V9.49967ZM9.50146 6.33301V9.49967H3.34782L3.33496 9.49951L3.3221 9.49967H2.16797V6.33301H9.50146ZM13.7515 5.33268H10.6539L10.6539 5.33259C10.7712 4.96236 10.9548 4.47401 11.2208 3.99031C11.7645 3.00185 12.5712 2.16602 13.7515 2.16602C14.1714 2.16602 14.5741 2.33283 14.8711 2.62976C15.168 2.9267 15.3348 3.32942 15.3348 3.74935C15.3348 4.16928 15.168 4.572 14.8711 4.86893C14.5741 5.16587 14.1714 5.33268 13.7515 5.33268Z" fill="#1A1A1A"/></svg>ギフトオプションを設定する</span><span></span>';
    titleEl.classList.add('js-giftship-accordion-toggle', 'custom-gs-accordion-label', 'c-txt--bold', 'c-txt__reading');
    titleEl.setAttribute('tabindex', '0');
    titleEl.setAttribute('role', 'button');
    titleEl.setAttribute('aria-expanded', 'false');

    // 開閉状態を制御する関数
    function toggleAccordion() {
      const isOpen = gsAppContainer.classList.contains('is-open');
      if (isOpen) {
        gsAppContainer.classList.remove('is-open');
        titleEl.setAttribute('aria-expanded', 'false');
        // 閉じる：高さ0&属性セット
        optionRowsWrapper.style.maxHeight = '0px';
        optionRows.forEach(function(row) {
          row.setAttribute('data-gs-accordion', 'closed');
        });
      } else {
        gsAppContainer.classList.add('is-open');
        titleEl.setAttribute('aria-expanded', 'true');
        // 開く：内容の高さを取得しmax-heightをセット
        // スクロール高さ=内容の全高
        optionRowsWrapper.style.maxHeight = optionRowsWrapper.scrollHeight + 'px';
        optionRows.forEach(function(row) {
          row.setAttribute('data-gs-accordion', 'open');
        });
      }
    }

    // transition後に、開いていればmax-heightをnoneにして無制限に
    optionRowsWrapper.addEventListener('transitionend', function(e) {
      if (gsAppContainer.classList.contains('is-open')) {
        optionRowsWrapper.style.maxHeight = 'none';
      }
    });

    // 開くときは都度max-heightを内容の高さに戻す
    // 閉じるときは0pxへ
    titleEl.addEventListener('click', function() {
      // max-height: none のままだとtransition効かないため一度戻す
      if (!gsAppContainer.classList.contains('is-open')) {
        optionRowsWrapper.style.transition = 'none';
        optionRowsWrapper.style.maxHeight = '0px';
        // reflow
        void optionRowsWrapper.offsetWidth;
        optionRowsWrapper.style.transition = 'max-height 0.3s cubic-bezier(0.4,0,0.2,1)';
      }
      toggleAccordion();
    });

    // キーボード操作対応（Enter/Space）
    titleEl.addEventListener('keydown', function(e) {
      // Enter, Spaceで開閉
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!gsAppContainer.classList.contains('is-open')) {
          optionRowsWrapper.style.transition = 'none';
          optionRowsWrapper.style.maxHeight = '0px';
          void optionRowsWrapper.offsetWidth;
          optionRowsWrapper.style.transition = 'max-height 0.3s cubic-bezier(0.4,0,0.2,1)';
        }
        toggleAccordion();
      }
    });

    // タイトルinsert
    textContainer.insertAdjacentElement('afterbegin', titleEl);
  }


  // テキストインプットに注釈を追加
  const $textInput = gsAppContainer.querySelector('.gs__product-option[data-child-type="text"]')
  if ($textInput) {
    const noteContent = `<span>贈り主のお名前を連名で入れる場合には、3名様までとさせていただきます。<br>
    それ以上の場合は、ご一同様(例：有志一同、家族一同、総務課一同等)での記載をお願いいたします。<br><br>
      連名の場合には、お名前とお名前の間に／で区切りを入れてください。(例：鈴木／佐藤／高橋)<br>
      のし下にはご入力いただいた左側のお名前から順に縦書きで右から左の順に印字いたします。<br>
      (例：「鈴木／佐藤／高橋」とご入力いただいた場合、[右]鈴木 (改行) [中央]佐藤 (改行) [左]高橋の順に印字)<br></span>`
    $textInput.querySelector('label').insertAdjacentHTML('beforeend', noteContent)
  }

  // テキストインプットの文字数が30より多い場合のエラー表示
  if ($textInput) {
    const inputField = $textInput.querySelector('input[type="text"], textarea');
    if (inputField) {
      inputField.addEventListener('input', function() {
        if (inputField.value.length > 30) {
          $textInput.classList.add('is-custom-text-error');
          submitButton.setAttribute('disabled', 'disabled');
        } else {
          $textInput.classList.remove('is-custom-text-error');
          submitButton.removeAttribute('disabled');
        }
      });
      // 初期状態でも確認
      if (inputField.value.length > 30) {
        $textInput.classList.add('is-custom-text-error');
        submitButton.setAttribute('disabled', 'disabled');
      }
    }
  }
});